import Constant from '@/common/constant/Constant';
import { useState, useEffect } from 'react';
import RichTextEditor from '@/component/formManagement/fieldUI/RichTextEditor';
import { Checkbox, FormControlLabel } from '@material-ui/core';

export default function ReplyCheckboxDeliver({
    originTicket,
    replyToEmailTicket,
    replyDeliverStatus,
    setReplyDeliverStatus,
    currentEmailTicket,
    currentTicketDeliverStatus,
    setCurrentTicketDeliverStatus,
    setIsEdited                    
}) {

    return (
        <div className='form-addTicket'>
            <FormControlLabel
                control={
                        <Checkbox 
                        checked={replyDeliverStatus} 
                        onChange={e => setReplyDeliverStatus(!replyDeliverStatus)}
                    />
                }
                label={'メール配信'} 
                className={`checkbox-item-of-tag-field`}
            />
        </div>
    );

}
